import { render, staticRenderFns } from "./KSnackbarSimple.vue?vue&type=template&id=ce8a797e&scoped=true"
import script from "./KSnackbarSimple.vue?vue&type=script&lang=js"
export * from "./KSnackbarSimple.vue?vue&type=script&lang=js"
import style0 from "./KSnackbarSimple.vue?vue&type=style&index=0&id=ce8a797e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8a797e",
  null
  
)

export default component.exports